import { Component, Input, OnInit } from '@angular/core';
import {environment} from "../../../../environments/environment";

@Component({
    selector: 'app-card-status-success',
    templateUrl: './card-status-success.component.html',
    styleUrls: ['./card-status-success.component.scss', '../cardstatus.component.scss'],
    standalone: false
})
export class CardStatusSuccessComponent implements OnInit {

    @Input()
    message!: string;

    constructor() {
    }

    ngOnInit(): void {
    }

    returnToHomePage(): void {
        window.location.href = `${environment.portalHomeUrl}/driver-licensing`;
    }
}
